import {PLATFORM_AREA, COMPONENT_ID, RIA_COMPONENT, NOTIFICATION_TYPE} from '@advisor/util/constants';
import store from '@advisor/store';
import AdvCommonUtilMethods from '@advisor/util/AdvCommonUtilMethods';

export default [
  {
    path: '/advisor/initiate-account-transfer',
    component: () => import('@advisor/components/activity/accountTransfer/Wizard'),
    name: 'InitiateAccountTransfer',
    meta: {
      platformArea: PLATFORM_AREA.ACTIVITY,
      visibilityComponentId: COMPONENT_ID.ACTIVITY,
      riaComponent: RIA_COMPONENT.ACTIVITY,
    },
    beforeEnter: async (to, from, next) => {
      if (!AdvCommonUtilMethods.clientViewOnlyCheck(to, from, next)) {
        return;
      }

      if (from.params.clientId || to.params.clUserId) {
        // eslint-disable-next-line no-param-reassign
        to.params.clUserId = to.params.clUserId ? to.params.clUserId : from.params.clientId;
      }

      try {
        await Promise.all([
          // Load the first step
          store.dispatch('accountTransfer/setActiveTab', {
            activeTab: 0,
          }),
          // Load Aggregator Institutions
          store.dispatch('accountTransfer/getAggregatorInstitutions'),
        ]).then(() => next());
      } catch {
        const msg = {
          type: NOTIFICATION_TYPE.ERROR,
          text: 'Error: Money Transfer details could not be retrieved.',
          timeout: 5,
        };

        store.dispatch('notification/setMessage', msg);
      }

      next();
    },
  },
];
